// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropType from 'prop-types';
import { navigationLogoItemPropType } from '../propTypes';
import ExploreItem from './ExploreItem';
import styled from '../utils/styled';
import { mediaBreakpointUpXL } from '../../constants/style-constants';

const gridRowRepeat = itemCount => Math.ceil(itemCount / 2);

const NavigationColumn = styled.ul(({ itemCount }) => ({
  /* stylelint-disable selector-type-case, selector-type-no-unknown, function-name-case */
  display: 'flex',
  flexDirection: 'column',
  margin: '0',
  padding: '0',

  [mediaBreakpointUpXL]: {
    columnGap: '30px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridAutoRows: 'max-content',
    gridTemplateRows: `repeat(${gridRowRepeat(itemCount)}, auto)`,
    gridAutoFlow: 'column dense',
    margin: '0 15px',
  },
}));

const ExploreList = ({
  items, onHoverItem, onMouseLeave, rootElementId,
}) => (
  <NavigationColumn itemCount={items.length} id={rootElementId} onMouseLeave={onMouseLeave} role="menu">
    {items.map(item => (
      <ExploreItem key={`${rootElementId}-${item.title}`} item={item} onHoverItem={onHoverItem} />
    ))}
  </NavigationColumn>
);

ExploreList.propTypes = {
  rootElementId: PropType.string.isRequired,
  items: PropType.arrayOf(navigationLogoItemPropType),
  onHoverItem: PropType.func,
  onMouseLeave: PropType.func.isRequired,
};

ExploreList.defaultProps = {
  items: [],
  onHoverItem: () => undefined,
};

export default ExploreList;
